import { placementConfig } from './placementConfig';
import type { SupportedLocale } from '@99designs/i18n';
import type { Placement } from '../types';

export function isPlacementLocaleSupported(placement: Placement, locale: string): boolean {
    return placementConfig[placement].includes(locale.toLowerCase() as SupportedLocale);
}
